import { render, staticRenderFns } from "./saleOrder.vue?vue&type=template&id=ffaf9ed6&scoped=true&"
import script from "./saleOrder.vue?vue&type=script&lang=js&"
export * from "./saleOrder.vue?vue&type=script&lang=js&"
import style0 from "./saleOrder.vue?vue&type=style&index=0&id=ffaf9ed6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffaf9ed6",
  null
  
)

export default component.exports